import {http} from '@/axios'
import router from '@/router'

export default {
  namespaced: true,
  state: {
    loaded: false,
    promiseUser: null,
    pendingLoad: false,
    pendingAuth: false,
    pendingUpdate: false,
    profile: null,
    token: null
  },
  getters: {
    isLogged(state) {
      return !!state.token
    }
  },
  mutations: {
    setProperty(store, [key, value]) {
      store[key] = value
    }
  },
  actions: {
    init({commit, dispatch}) {
      let token = getTokenFromLocalStorage()

      if (token) {
        commit('setProperty', ['token', token])
        http.defaults.headers.common['Auth-Key'] = token
        dispatch('load')
      }
    },
    load({state, commit}) {
      if (state.loaded) return Promise.resolve()
      if (state.pendingLoad) {
        return state.promiseUser
      }
      commit('setProperty', ['pendingLoad', true])

      const promiseUser = http.get('/api/user/settings').then(({data}) => {
        commit('setProperty', ['profile', data.data])
        return data.data
      }).catch(e => {
        // dispatch('logout')
        console.log(e)
        throw e
      }).finally(() => {
        commit('setProperty', ['loaded', true])
        commit('setProperty', ['pendingLoad', false])
        commit('setProperty', ['promiseUser', null])
      })
      commit('setProperty', ['promiseUser', promiseUser]);
      return promiseUser
    },
    registration({commit, dispatch}, sendData) {
      dispatch('logout')
      commit('setProperty', ['pendingAuth', true])

      return http.post('/api/user/signup', sendData).then(async ({data}) => {
        addTokenToLocalStorage(data.data.auth_key)
        commit('setProperty', ['profile', data.data])
        commit('setProperty', ['token', data.data.auth_key])
        http.defaults.headers.common['Auth-Key'] = data.data.auth_key

        return data
      }).finally(() => {
        commit('setProperty', ['pendingAuth', false])
      })
    },
    login({commit, dispatch}, sendData) {
      dispatch('logout')
      commit('setProperty', ['pendingAuth', true])

      return http.post('/api/user/login', sendData).then(async ({data}) => {
        addTokenToLocalStorage(data.data.auth_key)
        commit('setProperty', ['profile', data.data])
        commit('setProperty', ['token', data.data.auth_key])
        http.defaults.headers.common['Auth-Key'] = data.data.auth_key

        return data
      }).finally(() => {
        commit('setProperty', ['pendingAuth', false])
      })
    },
    updateProfile({commit}, sendData) {
      commit('setProperty', ['pendingUpdate', true])
      return http.post('/api/user/settings', sendData).then(async ({data}) => {
        commit('setProperty', ['profile', data.user])
        return data
      }).finally(() => {
        commit('setProperty', ['pendingUpdate', false])
      })
    },
    changePassword({commit}, sendData) {
      commit('setProperty', ['pendingUpdate', true])

      return http.post('/api/user/change-password', sendData).then(async ({data}) => {
        //addTokenToLocalStorage(data.item.auth_key)
        //commit('setProperty', ['profile', data.data])
        //commit('setProperty', ['token', data.data.auth_key])
        //commit('setProperty', ['loaded', false])
        //http.defaults.headers.common['Auth-Key'] = data.data.auth_key
        return data
      }).finally(() => {
        commit('setProperty', ['pendingUpdate', false])
      })
    },
    resetPassword({commit, dispatch}, sendData) {
      dispatch('logout')
      commit('setProperty', ['pendingAuth', true])

      return http.post('/api/user/request-password-reset', sendData).then(async ({data}) => {
        return data
      }).finally(() => {
        commit('setProperty', ['pendingAuth', false])
      })
    },
    restorePassword({commit, dispatch}, sendData) {
      dispatch('logout')
      commit('setProperty', ['pendingAuth', true])

      return http.post('/api/user/reset-password', sendData).then(async ({data}) => {
        return data
      }).finally(() => {
        commit('setProperty', ['pendingAuth', false])
      })
    },
    logout({commit}) {
      commit('setProperty', ['profile', null])
      commit('setProperty', ['token', null])
      commit('setProperty', ['loaded', false])
      http.defaults.headers.common['Auth-Key'] = null
      removeTokenFromLocalStorage()

      const isRequiresAuth = !!router.currentRoute.matched.find(record => {
        return record.meta.requiresAuth
      })

      if (isRequiresAuth) {
        router.push({name: 'home'})
      }
    }
  }
}

function addTokenToLocalStorage(token) {
  if (!token) return
  return localStorage.setItem('token', token)
}

function removeTokenFromLocalStorage() {
  localStorage.removeItem('token')
}

function getTokenFromLocalStorage() {
  return localStorage.getItem('token') || null
}
